const targetItems = document.querySelectorAll('.accordion-item');

targetItems.forEach((t) => {
    t.addEventListener('click', function() {
        targetItems.forEach((x) => {
            if (x.classList.contains('active') && x !== t) {
                x.classList.remove('active');
                x.querySelector('.accordion-item-panel').style.height = '0';
            }
        });

        const panel = t.querySelector('.accordion-item-panel');

        if (t.classList.contains('active')) {
            t.classList.remove('active');
            panel.style.height = '0';
        } else {
            t.classList.add('active');
            panel.style.height = panel.querySelector('.panel-inner').scrollHeight + 'px';
        }
    });
});
